document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- AJAX add-to-cart ---------------- */
  function showCartNotification(message) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2500);
  }

  function refreshCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.textContent = formatMoney(cart.total_price);
        });
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  document.body.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-add-form]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var originalHTML = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        refreshCartBubble();
        showCartNotification('Added to cart');
      })
      .catch(function (err) {
        showCartNotification((err && err.description) || 'Could not add item to cart');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.innerHTML = originalHTML;
        }
      });
  });

  /* ---------------- Cart qty stepper +/- buttons ---------------- */
  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-dec],[data-qty-inc]');
    if (!btn) return;
    var input = btn.closest('.qty-stepper').querySelector('input');
    var val = parseInt(input.value) || 0;
    if (btn.hasAttribute('data-qty-dec')) val = Math.max(0, val - 1);
    else val = val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change'));
  });

  /* ---------------- Cart page quantity updates ---------------- */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });

  /* ---------------- Sort ---------------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------------- Grid / list view toggle ---------------- */
  var viewButtons = document.querySelectorAll('[data-view-btn]');
  var grid = document.querySelector('[data-product-grid]');
  viewButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var view = btn.getAttribute('data-view-btn');
      viewButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      if (grid) {
        grid.setAttribute('data-view', view);
        grid.querySelectorAll('[data-product-card]').forEach(function (card) {
          card.classList.toggle('product-card--list', view === 'list');
          card.classList.toggle('product-card--grid', view === 'grid');
        });
      }
    });
  });

  /* ---------------- Client-side condition / price filtering ---------------- */
  var conditionCheckboxes = document.querySelectorAll('[data-condition-checkbox]');
  var priceMin = document.querySelector('[data-price-min]');
  var priceMax = document.querySelector('[data-price-max]');
  var applyPriceBtn = document.querySelector('[data-apply-price]');
  var resetButtons = document.querySelectorAll('[data-reset-filters]');
  var activeFiltersBox = document.querySelector('[data-active-filters]');
  var activeFilterBadges = document.querySelector('[data-active-filter-badges]');
  var visibleCountEl = document.querySelector('[data-visible-count]');
  var emptyState = document.querySelector('[data-empty-state]');

  function applyFilters() {
    if (!grid) return;
    var cards = grid.querySelectorAll('[data-product-card]');
    var selectedConditions = Array.prototype.slice.call(conditionCheckboxes)
      .filter(function (cb) { return cb.checked; })
      .map(function (cb) { return cb.value; });

    var min = parseFloat(priceMin && priceMin.value) || 0;
    var max = parseFloat(priceMax && priceMax.value) || Infinity;

    var visible = 0;
    cards.forEach(function (card) {
      var condition = card.getAttribute('data-condition') || '';
      var price = parseFloat(card.getAttribute('data-price')) || 0;

      var matchCondition = selectedConditions.length === 0 || selectedConditions.indexOf(condition) !== -1;
      var matchPrice = price >= min && price <= max;
      var show = matchCondition && matchPrice;

      card.hidden = !show;
      if (show) visible++;
    });

    if (visibleCountEl) visibleCountEl.textContent = visible;
    if (emptyState) emptyState.hidden = visible !== 0;

    var badges = [];
    selectedConditions.forEach(function (c) { badges.push('Condition: ' + c); });
    if (min > 0) badges.push('Min $' + min);
    if (isFinite(max)) badges.push('Max $' + max);

    if (activeFiltersBox && activeFilterBadges) {
      if (badges.length > 0) {
        activeFiltersBox.hidden = false;
        activeFilterBadges.innerHTML = badges.map(function (b) { return '<span>' + b + '</span>'; }).join('');
      } else {
        activeFiltersBox.hidden = true;
        activeFilterBadges.innerHTML = '';
      }
    }
  }

  conditionCheckboxes.forEach(function (cb) { cb.addEventListener('change', applyFilters); });
  if (applyPriceBtn) applyPriceBtn.addEventListener('click', applyFilters);

  resetButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      conditionCheckboxes.forEach(function (cb) { cb.checked = false; });
      if (priceMin) priceMin.value = '';
      if (priceMax) priceMax.value = '';
      applyFilters();
    });
  });

  /* ---------------- Product detail thumbnail swap ---------------- */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-detail__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-thumb-src');
    });
  });
});
